<template>

    <vs-row>
    
        <vs-col vs-lg="12" vs-xs="12">
        
            <vs-card>

                <h4 class="mb-1">%70</h4>
                <span>Onaylanan Etkinlik Sayısı</span>
                <vs-progress :percent="70" color="danger">primary</vs-progress>
            </vs-card>
        </vs-col>
       
        
       
    </vs-row>    
</template>
<script>
export default {
    name: "Etkinlikler"
}
</script>